import { INomenclature } from './nomenclature';
import { NomenclatureActions, NomenclatureActionTypes } from './nomenclature.actions';

export const nomenclatureStoreSelector = state => state.nomenclature as INomenclature;

export function nomenclatureReducer(
    state: INomenclature,
    action: NomenclatureActions
): INomenclature {

    switch (action.type) {
        case NomenclatureActionTypes.INITIALIZE:
            if(action.payload.nomenclature){
              return {
                  ...state,
                  countryCodes: action.payload.nomenclature.countryCodes,
                  postCodes: action.payload.nomenclature.postCodes
              }
            } else return state;
        case NomenclatureActionTypes.CLEAR:
            return null;
        default: return state;

    }

}
